import { AlignJustifyIcon, LayoutDashboardIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'

export default function ViewSwitcher({
	value,
	onChange,
}: {
	value: string
	onChange: (value: string) => void
}) {
	const { t } = useTranslation()

	return (
		<Tabs value={value} onValueChange={onChange}>
			<TabsList>
				<TabsTrigger
					value='table'
					onClick={() => {
						ampli.ogView({ mode: 'table' })
					}}
				>
					<Tooltip>
						<TooltipTrigger>
							<AlignJustifyIcon />
						</TooltipTrigger>
						<TooltipContent>
							{t('og.view.switcher.table.tooltip', {
								defaultValue:
									'This view visualise your Optimization groups data as list view',
							})}
						</TooltipContent>
					</Tooltip>
				</TabsTrigger>

				<TabsTrigger
					value='tree'
					onClick={() => {
						ampli.ogView({ mode: 'tree' })
					}}
				>
					<Tooltip>
						<TooltipTrigger>
							<LayoutDashboardIcon />
						</TooltipTrigger>
						<TooltipContent>
							{t('og.view.switcher.tree.tooltip', {
								defaultValue:
									'This view visualise your Optimization groups as tree view',
							})}
						</TooltipContent>
					</Tooltip>
				</TabsTrigger>
			</TabsList>
		</Tabs>
	)
}
